import ReactLoading from 'react-loading'

export const LoadingComponent = () => {
    return (
      <div className='flex flex-col justify-center items-center'>
        <ReactLoading type={"spin"} color="#f97316" height={100} width={100} />
      </div>
    )
  }